import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconFileTextEdit: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.725 11.4333L16.9 10.6083C16.6417 10.35 16.2992 10.2083 15.9351 10.2083C15.9342 10.2083 15.9334 10.2083 15.9334 10.2083C15.5684 10.2083 15.2241 10.3516 14.9674 10.6108L10.3916 15.2075C10.2741 15.3241 10.2091 15.4833 10.2091 15.6483V17.5C10.2091 17.845 10.4891 18.125 10.8341 18.125H12.6868C12.8518 18.125 13.0108 18.0591 13.1274 17.9425L17.7242 13.3666C17.9834 13.1091 18.125 12.7658 18.1258 12.4008C18.125 12.0358 17.9834 11.6925 17.725 11.4333ZM15.9342 11.4583C15.9559 11.4583 15.9875 11.4641 16.0158 11.4924L16.8408 12.3175C16.8692 12.3458 16.875 12.3783 16.875 12.4C16.875 12.4216 16.8692 12.4533 16.8408 12.4816L16.3108 13.0091L15.3241 12.0225L15.8516 11.4924C15.8808 11.4641 15.9126 11.4583 15.9342 11.4583ZM12.4276 16.875H11.4583V15.9058L14.4425 12.9083L15.425 13.8908L12.4276 16.875ZM8.33333 16.0416H5C3.68583 16.0416 3.125 15.4808 3.125 14.1666V4.16663C3.125 2.85246 3.68583 2.29163 5 2.29163H9.375V4.16663C9.375 6.18163 10.485 7.29163 12.5 7.29163H14.375V8.33329C14.375 8.67829 14.655 8.95829 15 8.95829C15.345 8.95829 15.625 8.67829 15.625 8.33329V6.66663C15.625 6.50079 15.5592 6.34163 15.4417 6.22496L10.4417 1.22496C10.3242 1.10746 10.1658 1.04163 10 1.04163H5C2.985 1.04163 1.875 2.15163 1.875 4.16663V14.1666C1.875 16.1816 2.985 17.2916 5 17.2916H8.33333C8.67833 17.2916 8.95833 17.0116 8.95833 16.6666C8.95833 16.3216 8.67833 16.0416 8.33333 16.0416ZM10.625 4.16663V3.1758L13.4908 6.04163H12.5C11.1858 6.04163 10.625 5.48079 10.625 4.16663ZM5.83333 8.54163C5.48833 8.54163 5.20833 8.82163 5.20833 9.16663C5.20833 9.51163 5.48833 9.79163 5.83333 9.79163H11.6667C12.0117 9.79163 12.2917 9.51163 12.2917 9.16663C12.2917 8.82163 12.0117 8.54163 11.6667 8.54163H5.83333ZM9.16667 11.875H5.83333C5.48833 11.875 5.20833 12.155 5.20833 12.5C5.20833 12.845 5.48833 13.125 5.83333 13.125H9.16667C9.51167 13.125 9.79167 12.845 9.79167 12.5C9.79167 12.155 9.51167 11.875 9.16667 11.875Z"
      fill={color}
    />
  </svg>
);

export default IconFileTextEdit;
